import { FlexDiv } from "@/sharedStyled";
import { Switch } from "antd";
import { bool, exact, func, string } from "prop-types";

export const PermissionRight = ({
  right,
  right: { id, selected, disabled, description },
  handleToggleRight,
}) => (
  <>
    <FlexDiv style={{ paddingTop: "10px" }}>
      <FlexDiv style={{ flexGrow: 1 }}>
        <strong>{id}</strong>
      </FlexDiv>
      <FlexDiv>
        <Switch
          data-test-id={`permission-selection-generate-permission-${id}`}
          checked={selected}
          onChange={(checked) => handleToggleRight(right, checked)}
          disabled={disabled}
        />
      </FlexDiv>
    </FlexDiv>
    <FlexDiv
      style={{
        paddingLeft: "10px",
      }}
    >
      {description}
    </FlexDiv>
  </>
);

PermissionRight.propTypes = {
  right: exact({
    id: string.isRequired,
    selected: bool.isRequired,
    disabled: bool.isRequired,
    description: string.isRequired,
  }).isRequired,
  handleToggleRight: func.isRequired,
};
